import { BaseTopMenuApi } from './api.base';

export class CloudTopMenuApi extends BaseTopMenuApi {

}
